import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { NotificationService, GridDataSource, LoaderService, CONSTANT, ErrorService, EVENTO, TOOLTIPS, ICONS, ACTIONS, TYPEMESSAGE, UtilityService } from "../../../../shared/session/index";
import { Documento, Idocumento } from "../shared/documento.model";
import { DocumentoService } from '../shared/documento.service';
import { RegularExpressionMessage, RegularExpression, CustomValidators } from '../../../../shared/validation/customvalidation';
import { MatTreeModule } from '@angular/material';
import { FileuploadComponent } from 'src/app/shared/fileupload/fileupload.component';
import { FileuploadService } from 'src/app/shared/fileupload/fileupdate.service';

@Component({
  //moduleId: module.id,
  selector: 'app-documento-edit',
  templateUrl: 'documento-edit.component.html'
})
export class DocumentoEditComponent implements OnInit {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Input() data: any;
  @Input() titlePage: string;
  @ViewChild(FileuploadComponent) fileuploadComponent: FileuploadComponent;

  formGroupEditDocumento: FormGroup;
  buttonGroup: any;
  documento: Idocumento;
  nomDocumentoMaxLength: number;
  pasMaxLength: string;
  descripcionMaxLength: number;
  msgErrorActualizar: string;
  msgErrorGet: string;
  obligatorioMsg: string;
  maxLengthMsg: string;
  nomUserPatternMsg: string = RegularExpressionMessage.LETRAS_TILDE_ENIE_MSG;
  nomPathMaxLength: number;
  public typeImage: number;

  constructor(
    private loaderService: LoaderService,
    private documentoService: DocumentoService,
    private notificationService: NotificationService,
    private errorService: ErrorService,
    private fileuploadService: FileuploadService,
    public fb: FormBuilder
  ) { }

  ngOnInit() {
    this.buttonGroup = [
      { tooltip: TOOLTIPS.save, icon: ICONS.save, action: ACTIONS.save }
    ];
    this.msgErrorActualizar = 'Error al actualizar datos';
    this.msgErrorGet = 'Error al obtener datos';
    this.obligatorioMsg = 'Campo Obligatorio';
    this.documento = new Documento(1, "", "", "", true, "", "", "", "", "", "");
    this.typeImage = CONSTANT.typeImage.edit;

    this.setValuesFormBuilder();
    this.obtenerDocumento(this.data.documento.ID);
  }

  private setValuesFormBuilder() {
    this.formGroupEditDocumento = this.fb.group({

      propietarioID: [this.documento.userName, Validators.compose([
        Validators.required,
        Validators.maxLength(this.nomDocumentoMaxLength),
        // CustomValidators.pattern(RegularExpression.SOLO_NUMERO)
      ])],
      descripcion: [this.documento.descripcion, Validators.compose([
        Validators.required,
        Validators.maxLength(this.descripcionMaxLength),
      ])],
      ruta: [this.documento.FotoRuta, Validators.compose([
        Validators.required,
        Validators.maxLength(this.descripcionMaxLength),
      ])],
      status: [this.documento.status],
    });
  }

  formGroupEditDocumentoSubmit(event) {
    if (this.formGroupEditDocumento.invalid)
      return;

    this.documento.propietarioID = this.data.user.ID;
    this.documento.descripcion = event.value.descripcion;

    this.documento.status = event.value.status;
    this.fileuploadComponent.insertFile(CONSTANT.imagen.clase.documento, CONSTANT.imagen.tipo.usuario, this.documento.FotoRuta, this.documento.propietarioID.toString());
    if (this.fileuploadComponent.imageName)
      this.documento.FotoRuta = this.fileuploadComponent.imageName;
    else
      this.documento.FotoRuta = '';

    this.documento.claseArchivo = CONSTANT.imagen.clase.documento;
    this.actualizarDocumento(this.documento);
  }

  changeEvent(documento: Idocumento) {
    this.data.documento = { ID: this.data.documento.ID, Name: this.data.documento.Name };
    this.onChangeEvent.emit({ evento: EVENTO.consultar, data: this.data });
  }

  private actualizarDocumento(documento: Idocumento) {
    this.loaderService.show();
    this.documentoService.actualizarDocumento(documento)
      .subscribe(res => {
        this.changeEvent(documento);
        // }
        this.notificationService.successful("Se grabo satisfactoriamente");

      },
        error => {
          this.notificationService.error(this.msgErrorActualizar);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }

  private obtenerDocumento(documentoID: number): void {
    this.loaderService.show();
    this.documentoService.obtenerDocumento(documentoID)
      .subscribe(res => {
        this.documento = res;
        this.fileuploadComponent.getFile(CONSTANT.imagen.clase.documento, CONSTANT.imagen.tipo.usuario, this.documento.FotoRuta);
      },
        error => {
          this.notificationService.error(this.msgErrorGet);
          throw error;
        },
        () => {
          this.setValuesFormBuilder();
          this.loaderService.hide();
        });
  }


}
